import styled from '@emotion/styled';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {EndAdornmentIconWrapper, ETooltip} from 'webapp-lib/Components';

import {
  Archive,
  CasusInactive,
  CasusProtected,
  Internal,
  Lock,
} from '_/assets/images';
import {CasusState} from '_/types/casus';

export const CasusFlags = ({
  isInternal,
  isProtected,
  isLocked,
  state,
}: {
  isInternal: boolean;
  isProtected: boolean;
  isLocked: boolean;
  state: CasusState;
}): React.ReactElement => {
  const {t} = useTranslation('casus');

  return (
    <CasusFlagsIconsWrapper>
      {isInternal ? (
        <CasusIcon title={t('icons.internal')}>
          <Internal />
        </CasusIcon>
      ) : null}
      {isProtected ? (
        <CasusIcon title={t('icons.protected')}>
          <CasusProtected />
        </CasusIcon>
      ) : null}
      {isLocked ? (
        <CasusIcon title={t('icons.locked')}>
          <Lock />
        </CasusIcon>
      ) : null}
      {state === 'INACTIVE' ? (
        <CasusIcon title={t('icons.inactive')}>
          <CasusInactive />
        </CasusIcon>
      ) : null}
      {state === 'ARCHIVED' ? (
        <CasusIcon title={t('icons.archived')}>
          <Archive />
        </CasusIcon>
      ) : null}
    </CasusFlagsIconsWrapper>
  );
};

const CasusIcon = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <ETooltip title={title}>
    <EndAdornmentIconWrapper>{children}</EndAdornmentIconWrapper>
  </ETooltip>
);

const CasusFlagsIconsWrapper = styled.div`
  display: flex;
  gap: var(--gutter-little);
`;
